import { __awaiter } from '../_virtual/_tslib.js';
import { useHandleModalToggle } from './useHandleModalToggle.js';
import { useHistory } from 'react-router-dom';
import { toast } from '../components/toast/toast.js';
import { LOC_STORAGE } from '../constants/misc.js';
import { getTimeDiffMs } from '../methods/getTimeDiffMs.js';

function useToggleCBRModal() {
    const history = useHistory();
    // Check if callback is requested less than 24 hours
    const checkCallbackRequestedTimeStamp = () => {
        const oneDay = 60 * 60 * 24 * 1000;
        const callbackTimestamp = window.localStorage.getItem(LOC_STORAGE.callbackRequestedTimestamp);
        // Check if callback is requested less than 24 hours
        if (callbackTimestamp === (null) ||
            getTimeDiffMs(callbackTimestamp, new Date().toISOString()) > oneDay) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Custom Hooks
     */
    const { openModal, closeModal } = useHandleModalToggle(["isCallbackRequestPopupVisible"]);
    const toggleCBRModal = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!((_a = history.location.state) === null || _a === void 0 ? void 0 : _a.isCallbackRequestPopupVisible)) {
            if (checkCallbackRequestedTimeStamp()) {
                openModal();
            }
            else {
                toast.info("Your request is being processed, we'll get back to you shortly");
                return false;
            }
        }
        else {
            closeModal();
        }
    });
    return { toggleCBRModal, checkCallbackRequestedTimeStamp };
}

export { useToggleCBRModal };
//# sourceMappingURL=useCallbackRequestedState.js.map
